import { useAuthStep } from "@/hooks/useAuthStep";
import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";


const NavButtons = React.memo(({ handleBack, handleSkip }: { handleBack: (() => void) | null; handleSkip: (() => void) | null }) => {

	if (!handleBack && !handleSkip) return null;

	return (
		<div className="mt-[10px] flex justify-between items-center">
			{handleBack && (
				<button onClick={handleBack} className="flex items-center gap-[8px] font-medium">
					<ChevronLeft className="w-[20px] h-[20px]" />
					<span>Back</span>
				</button>
			)}
			{handleSkip && (
				<button onClick={handleSkip} className="ml-auto font-medium flex items-center gap-[8px]">
					Skip
					<ChevronRight className="w-[20px] h-[20px]" />
				</button>
			)}
		</div>
	)

});

const NavHeader = React.memo(({ handleBack, handleSkip }: { handleBack: (() => void) | null; handleSkip: (() => void) | null }) => {

	const { authStep } = useAuthStep();

	return (
		<div className="px-[30px] mt-[30px] mb-4">
			<img src={authStep === "thankYou" ? "/iconemptylg.png" :"/extlogo.png"} alt="logo" className={authStep === "thankYou" ? "size-[44px]" : "size-[30px]"} 	/>
			<NavButtons handleBack={handleBack} handleSkip={handleSkip} />
		</div>
	);
});

export default NavHeader;